// Shared suppliers data - single source of truth
// Used by both Products page (manufacturer dropdown) and Procurement page (supplier list)

export interface Supplier {
  id: number;
  name: string;
  code: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  payment_terms: string;
  lead_time_days: number;
  open_po_count: number;
  total_open_value: number;
  is_active: boolean;
}

export const suppliers: Supplier[] = [
  {
    id: 1,
    name: 'SMC',
    code: 'SUP-SMC',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
  {
    id: 2,
    name: 'IFM',
    code: 'SUP-IFM',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
  {
    id: 3,
    name: 'Kobi Technologies',
    code: 'SUP-KOBI',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
  {
    id: 4,
    name: 'Atka',
    code: 'SUP-ATKA',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
  {
    id: 5,
    name: 'דיקסה',
    code: 'SUP-DIKSA',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
  {
    id: 6,
    name: 'PARKER',
    code: 'SUP-PARKER',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
  {
    id: 7,
    name: 'סקופ',
    code: 'SUP-SCOOP',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
  {
    id: 8,
    name: 'הדס',
    code: 'SUP-HADAS',
    contact_name: '',
    contact_email: '',
    contact_phone: '',
    payment_terms: 'Net30',
    lead_time_days: 14,
    open_po_count: 0,
    total_open_value: 0,
    is_active: true,
  },
];

// Helper to get supplier names for dropdowns
export function getSupplierNames(): string[] {
  return suppliers.map(s => s.name);
}

// Helper to get supplier by name
export function getSupplierByName(name: string): Supplier | undefined {
  return suppliers.find(s => s.name === name);
}
